import React, { useState, useEffect } from "react";
import { obtenerDatos } from "services/crudFirebase";
import CardCatalogue from "components/UI/CardCatalogue/CardCatalogue";
import { useHistory } from "react-router-dom";
import "./Catalogue.scss";
import { orderBy } from "natural-orderby";
import Searcher from "components/UI/Searcher/Searcher";
import PaginatorComponent from "components/UI/MaterialUIComponents/PaginatorComponent";

const Catalogue = ({ edit = false, setItems, newItems }) => {
	const history = useHistory();
	const [datosObtenidos, setDatosObtenidos] = useState([]);
	const [itemsPagination, setItemsPagination] = useState([]);
	const [page, setPage] = useState(1);
	const [itemsToShow] = useState(12);
	const [onSearch, setOnSearch] = useState(false);

	if (!edit) {
		if (window.localStorage.getItem("account") === "true") {
			history.push("/panel-control");
		}
	}

	const itemsOrdered = (items) => {
		return orderBy(
			items,
			[
				(v) => v.ModelosCompatibles[0].Brand,
				(v) => v.ModelosCompatibles[0].Model,
				(v) => v.Tipo,
			],
			["asc"]
		);
	};

	useEffect(() => {
		setDatosObtenidos(itemsOrdered(newItems));
	}, [newItems]);

	useEffect(() => {
		const actualizarDatos = async () => {
			let data = await obtenerDatos("CatalogoFlexores");
			updateItems(data);
		};
		actualizarDatos();
	}, []);

	useEffect(() => {
		itemsForPagination();
		window.scrollTo(0, 0);
	}, [page]);

	const itemsForPagination = () => {
		const indexOfTheFirstItem = (page - 1) * itemsToShow;
		const originalData = [...datosObtenidos];
		const result = originalData.splice(indexOfTheFirstItem, itemsToShow);
		setItemsPagination(result);
	};

	useEffect(() => {
		if (datosObtenidos !== undefined) {
			itemsForPagination();
		}
	}, [datosObtenidos]);

	const updateItems = (item) => {
		setDatosObtenidos(itemsOrdered(item));
		if (edit) {
			setItems(itemsOrdered(item));
		}
	};

	return (
		<>
			<Searcher
				items={datosObtenidos}
				setItems={setDatosObtenidos}
				setPage={setPage}
				setOnSearch={setOnSearch}
			/>
			<section className="catalogue">
				{datosObtenidos.length > 0 ? (
					itemsPagination.map((i) => {
						return (
							<CardCatalogue
								item={i}
								key={i.id}
								edit={edit}
								datosObtenidos={datosObtenidos}
								setDatosObtenidos={updateItems}
							/>
						);
					})
				) : !onSearch ? (
					<>
						<CardCatalogue loading={true} key="1" />
						<CardCatalogue loading={true} key="2" />
						<CardCatalogue loading={true} key="3" />
						<CardCatalogue loading={true} key="4" />
						<CardCatalogue loading={true} key="5" />
						<CardCatalogue loading={true} key="6" />
					</>
				) : (
					<>
						<h3 className="catalogue__noResults">
							No se encontraron resultados para su búsqueda
						</h3>
					</>
				)}
			</section>
			<PaginatorComponent
				setPage={setPage}
				totalItems={datosObtenidos.length}
				itemsToShow={itemsToShow}
				page={page}
			/>
		</>
	);
};

export default Catalogue;
